import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import uiConf from "../../config/uiConf";
import apiClient from "../../lib/common/apiClient";

import Dialog from "../dialog/functional/Dialog";
import DialogHeader from "../dialog/functional/DialogHeader";
import DialogHeaderWithClose from "../dialog/functional/DialogHeaderWithClose";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogContent from "../dialog/functional/DialogContent";
import DialogActions from "../dialog/functional/DialogActions";
import DialogActionButton from "../dialog/functional/DialogActionButton";

import MomSysBomBopTree from "../screens/MomSysBomBopTree";

function MomSysBomBopTreeDialog ( props ) {

    const { t } = useTranslation();

    const {

        id,
        product,

        moveable,
        resizable,
        fullWidth,
        maxWidth,

        onInitialized,

        ...others

    } = props;

    const [instance, setInstance] = useState ();
    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    const onDialogInitialized = ( instance ) => {

        setInstance ( instance );

        if ( onInitialized ) {

            onInitialized ( instance );
            
        }

    };

    const onCloseNotification = () => {

        setNotification((notification) => {

            return ({ ...notification, open: false });

        });

    };

    const onError = ( reason ) => {

        const msg = reason.response ? reason.response.data : reason.message || reason;

        setNotification({
            severity: "error",
            msg: typeof msg === "string" ? msg : String ( msg ),
            open: true,
        });

    };

    // 엑셀 다운로드는 responseType blob 이라 오류 본문도 Blob 이다 — 글자로 읽어 알림에 넣는다
    const readBlobText = ( blob ) => new Promise ( ( resolve ) => {

        const reader = new FileReader ();

        reader.onload = () => resolve ( String ( reader.result ) );
        reader.onerror = () => resolve ( "" );
        reader.readAsText ( blob );

    } );

    const onDownloadError = async ( reason ) => {

        const data = reason.response ? reason.response.data : undefined;

        if ( data instanceof Blob ) {

            const text = await readBlobText ( data );

            onError ( { response: { data: text || `${reason.response.status}` } } );

            return;

        }

        onError ( reason );

    };

    const doHandleFileStream = (result) => {
        const blob = new Blob([result.data]);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `BOM BOP File for ${product.materialCode} ${product.materialCodeVer} ${product.materialName}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(link.href);
    };

    const url = `/api/BomBopFileDownload/${product?.materialCode}/${product?.materialCodeVer}`;

    const fileDownload = () => {
        apiClient
            .get(url, { responseType: "blob" }) // Note : responseType := "blob" !!
            .then((result) => {
                doHandleFileStream(result);
                // 받은 뒤에 닫는다 — 먼저 닫으면 실패 알림이 닫힌 대화상자 안에 묻힌다
                if ( instance ) {
                    instance.hide ();
                }
            })
            .catch((reason) => onDownloadError(reason));
    }

    return (
        <Dialog
            id={id}
            title={t("dialog.title.MomSysBomBopTree")}
            moveable={moveable ? moveable : uiConf.dialogMoveable}
            resizable={resizable ? resizable : uiConf.dialogResizable}
            fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
            maxWidth="md"
            onInitialized={onDialogInitialized}
            {...others}
        >

            {uiConf.modalWithCloseButton ? (
                <DialogHeaderWithClose>
                    <DialogTitle>
                        {t("dialog.title.MomSysBomBopTree")}
                    </DialogTitle>
                </DialogHeaderWithClose>
            ) : (
                <DialogHeader>
                    <DialogTitle>
                        {t("dialog.title.MomSysBomBopTree")}
                    </DialogTitle>
                </DialogHeader>
            )}

            <DialogContent style={{height: "400px"}} dividers >
                <MomSysBomBopTree product={product} onError={onError} />
            </DialogContent>

            <Snackbar
                open={notification.open && notification.severity !== "success"}
                autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                onClose={onCloseNotification}
            >
                <Alert
                    onClose={onCloseNotification}
                    variant="filled"
                    severity={notification.severity}
                >
                    {notification.msg}
                </Alert>
            </Snackbar>

            <DialogActions {...others} >
                <DialogActionButton primary close={false} onClick={fileDownload} {...others}>{ "다운로드"}</DialogActionButton>                    
                <DialogActionButton primary close={true} {...others}>{ t("common.ok")}</DialogActionButton>                    
        </DialogActions>

        </Dialog>
    );

}

export default MomSysBomBopTreeDialog;
